import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLikesLight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.16634 14.6668V7.3335M1.83301 8.66683V13.3335C1.83301 14.0699 2.42996 14.6668 3.16634 14.6668H12.1172C13.1043 14.6668 13.9438 13.9466 14.0939 12.9709L14.8119 8.30428C14.9982 7.09276 14.0609 6.00016 12.8351 6.00016H10.4997C10.1315 6.00016 9.83301 5.70169 9.83301 5.3335V2.97739C9.83301 2.06949 9.09701 1.3335 8.18912 1.3335C7.97257 1.3335 7.77633 1.46103 7.68838 1.65891L5.3423 6.93759C5.2353 7.17834 4.99655 7.3335 4.73309 7.3335H3.16634C2.42996 7.3335 1.83301 7.93045 1.83301 8.66683Z",
		stroke: "#808080",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLikesLight;
